var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-player"},[_c('AutoPlayVideo',{attrs:{"src":_vm.videoSrc,"controls":true,"height":"auto"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }